import { ref, computed, onMounted, onUpdated } from 'vue'
import { useStore } from 'vuex'

import nameValidator from '../../foundation/js/inputValidators/nameValidator'
import textAreaValidator from '../../foundation/js/inputValidators/textAreaValidator'
import companyNameValidator from '../../foundation/js/inputValidators/companyNameValidator'

import FormInputTextField from 'components/FormInputTextField/FormInputTextField.vue'
import FormAddressField from 'components/FormAddressField/FormAddressField.vue'

export default {
    name: "DeliveryAddress",
    components: { FormInputTextField, FormAddressField },
    props: {
        showDifferentAddress: {
            type: Boolean,
            required: false,
            default: false
        },
        isStepSubmitting: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    setup(props) {
        const store = useStore()
        const getLabel = (labelKey) => store.getters['labels/getLabel']({ labelCollection: 'deliveryAddress', labelKey: labelKey })
        const getLabelCheckout = (labelKey) => store.getters['labels/getLabel']({ labelCollection: 'checkout', labelKey: labelKey })

        onMounted(() => {
            store.commit('checkout/set_delivery_data_validation_success', inputIsValid.value)
        })

        onUpdated(() => {
            store.commit('checkout/set_delivery_data_validation_success', inputIsValid.value)
        })

        const showDifferentAddress = ref(props.showDifferentAddress)
        const checkoutSteps = computed(() => store.state.checkout.checkoutSteps)
        const currentStep = computed(() => checkoutSteps.value.find(i => i.stepNumber === 2))
        const beenFilled = computed(() => currentStep.value.beenFilled)

        // use beenFilled to access whether step data is in sessionStorage, then make unSubmitted false only if it is
        const unSubmitted = computed(() => (beenFilled.value || !!props.isStepSubmitting) ? false : true)

        const deliveryNameInput = ref(store.state.checkout.stepTwo.differentAddressData.deliveryName)
        const deliveryNameInputFilled = computed(() => {
            return (!deliveryNameInput.value ? true : companyNameValidator(deliveryNameInput.value))
        })

        const deliveryDepartmentInput = ref(store.state.checkout.stepTwo.differentAddressData.deliveryDepartment)
        const deliveryDepartmentInputFilled = computed(() => {
            return (unSubmitted.value && !deliveryDepartmentInput.value) ? true : (deliveryDepartmentInput.value ? companyNameValidator(deliveryDepartmentInput.value) : true)
        })

        const firstNameInput = ref(store.state.checkout.stepTwo.differentAddressData.contactFirstName)
        const firstNameInputFilled = computed(() => {
            return (unSubmitted.value && !firstNameInput.value) ? true : (firstNameInput.value ? nameValidator(firstNameInput.value) : false)
        })

        const lastNameInput = ref(store.state.checkout.stepTwo.differentAddressData.contactLastName)
        const lastNameInputFilled = computed(() => {
            return (unSubmitted.value && !lastNameInput.value) ? true : nameValidator(lastNameInput.value)
        })

        const addressLineInput = ref(store.state.checkout.stepTwo.differentAddressData.addressLine)
        const addressLineInputFilled = computed(() => {
            return (unSubmitted.value && !addressLineInput.value) ? true : (addressLineInput.value.length > 2 && textAreaValidator(addressLineInput.value) && postalCodeInputFilled.value && cityInputFilled.value)
        })

        const postalCodeInput = ref(store.state.checkout.stepTwo.differentAddressData.postalCode)
        const postalCodeInputFilled = computed(() => {
            return (unSubmitted.value && !addressLineInput.value) ? true : (postalCodeInput.value.length === 4 && textAreaValidator(addressLineInput.value))
        })

        const cityInput = ref(store.state.checkout.stepTwo.differentAddressData.city)
        const cityInputFilled = computed(() => {
            return (unSubmitted.value && !addressLineInput.value) ? true : (cityInput.value.length > 2 && textAreaValidator(addressLineInput.value))
        })

        const inputIsValid = computed(function () {
            // only validation the required inputs    
            let addressFilled = addressLineInputFilled.value &&
                postalCodeInputFilled.value &&
                cityInputFilled.value

            return (
                firstNameInputFilled.value &&
                lastNameInputFilled.value &&
                addressFilled &&
                // in case of user returning to old session stached address info, 
                // check if they're filling in new values (emptied input)
                // TODO: czi, kontroller om beenFilled logikken er korrekt. Udkommenteret for nu,
                // og undersøger om nødvendige felter er udfyldt. Eftersom enkeltvis feltvalidering
                // virker nu, er det nok ikke nødvendigt at have beenFilled logikken her.
                // (beenFilled.value && (
                //     (addressLineInput.value ? true : false) &&
                //     (firstNameInput.value ? true : false) &&
                //     (lastNameInput.value ? true : false)
                //     )
                // )
                (addressLineInput.value ? true : false) &&
                (firstNameInput.value ? true : false) &&
                (lastNameInput.value ? true : false)
            )
        })

        const handleSendToStore = function () {
            if (!inputIsValid.value)
                return false

            const differentAddressData = {
                addressLine: addressLineInput.value,
                postalCode: postalCodeInput.value,
                city: cityInput.value,
                contactFirstName: firstNameInput.value,
                contactLastName: lastNameInput.value,
                deliveryName: deliveryNameInput.value,
                deliveryDepartment: deliveryDepartmentInput.value
            }

            // set delivery validation boolean in state
            store.commit('checkout/set_delivery_data_validation_success', inputIsValid.value)
            store.commit('checkout/set_different_address_data', differentAddressData)

            // if success set been filled to current step, as data is now in session storage
            store.commit('checkout/update_checkout_step_been_filled', 2)

            console.log("differentAddressData", differentAddressData)
        }

        return {
            getLabel,
            handleSendToStore,
            getLabelCheckout,
            showDifferentAddress,
            deliveryNameInput,
            deliveryDepartmentInput,
            firstNameInput,
            lastNameInput,
            addressLineInput,
            postalCodeInput,
            cityInput,
            deliveryNameInputFilled,
            deliveryDepartmentInputFilled,
            firstNameInputFilled,
            lastNameInputFilled,
            addressLineInputFilled,
            postalCodeInputFilled,
            cityInputFilled
        }
    }
}